import { arrInc } from '../../fun-js-lib/arr';
import { noHtmlTags } from '../../fun-js-lib/str';
import { getLinesFonted } from './draw-styled-text/line';
import { remarksLinesWidths } from './lower/remarks';
import { contentFont, maxNLinesOnMainPageWorkDescription, normalWorkDescriptionFont, workDescriptionMainPageContentRect } from './lower/workDescription';
import { maxNLinesOnOtherPage, otherPageContentRect } from './otherPageImg';

/**
 * @param {string} text 
 */
export function getPlainText (text) {
  if (text === '') { // can be an empty string when daily page has no entries (freshly created)
    return ''
  } else {
    text = JSON.parse(text).html
    text = text.replace(/<\/p>/g, '</p> ')
    text = noHtmlTags(text)
    text = text.replace(/&nbsp;/g, ' ')
    return text
  }
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} workDescriptionJson Either from remarks input field or from database
 */
export function nLinesInWorkDescription (context, workDescriptionJson) {
  const linesWidths = workDescriptionLinesWidths()
  // As function isn't called on first page, provide 2 as page number
  const font = contentFont(2)
  const lines = getLinesFonted(context, workDescriptionJson, linesWidths, font)
  return lines.length
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} remarksJson Either from remarks input field or from database
 */
export function nLinesInRemarks (context, remarksJson) {
  const linesWidths = remarksLinesWidths()
  const font = normalWorkDescriptionFont
  const lines = getLinesFonted(context, remarksJson, linesWidths, font)
  return lines.length
}

export const workDescriptionLinesWidths = () =>
  arrInc(maxNLinesOnMainPageWorkDescription).map(() => workDescriptionMainPageContentRect().w)
    .concat(arrInc(maxNLinesOnOtherPage).map(() => otherPageContentRect().w))